export default __webpack_public_path__ + "static/media/FAVICON_42.160d3e6e.png";